import { fromJS } from 'immutable';
import _ from 'lodash';

import * as smartListActions from '../actions/smartLists';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';

const updateStateArrayItem = (state, data, arrayName, idFieldName) =>
  state.setIn(
    [arrayName, 'data'],
    fromJS(
      state
        .getIn([arrayName, 'data'])
        .toJS()
        .map(x =>
          x[idFieldName] === _.get(data, `results[0].${idFieldName}`)
            ? data.results[0]
            : x,
        ),
    ),
  );

const initialState = fromJS({
  lists: {
    data: [],
    state: null,
  },
  modules: {
    data: [],
    state: null,
  },
  appraisalUsers: {
    data: [],
    state: null,
  },
  appraisalRoles: {
    data: [],
    state: null,
  },
  userAccess: {
    data: [],
    state: null,
  },
  roleAccess: {
    data: [],
    state: null,
  },
  parameters: {
    data: [],
    state: null,
  },
  executePreview: {
    data: [],
    recordCount: 0,
    columnOrder: [],
    state: null,
    errorMsg: '',
  },
  typeList: {
    data: [],
    state: null,
  },
  searchConfigList: {
    data: [],
    state: null,
  },
  searchConfigResultList: {
    data: [],
    state: null,
  },
  searchResultList: {
    searchOptions: {},
    data: [],
    state: null,
    pagination: {
      count: 0,
      page: 1,
      rowsPerPage: 25,
      rowsPerPageOptions: [5, 10, 25, 50],
      sortModel: [],
    },
  },
  searchValidationResultList: {
    searchOptions: {},
    data: [],
    state: null,
    pagination: {
      count: 0,
      page: 1,
      rowsPerPage: 25,
      rowsPerPageOptions: [5, 10, 25, 50],
      sortModel: [],
    },
  },
});

const SmartListReducer = (state = initialState, { type, data, ...other }) => {
  switch (type) {
    case smartListActions.FETCH_SMART_LIST[START]:
      return state.setIn(['lists', 'state'], fetchingState.FETCHING);
    case smartListActions.FETCH_SMART_LIST[SUCCESS]:
      if (
        state
          .getIn(['lists', 'data'])
          .toJS()
          .some(l => l.smartListID === _.get(data, `results[0].smartListID`))
      ) {
        return updateStateArrayItem(state, data, 'lists', 'smartListID').setIn(
          ['lists', 'state'],
          fetchingState.LOADED,
        );
      }
      return state.setIn(['lists', 'state'], fetchingState.LOADED).setIn(
        ['lists', 'data'],
        fromJS(
          state
            .getIn(['lists', 'data'])
            .toJS()
            .concat(data ? data.results[0] : []),
        ),
      );
    case smartListActions.FETCH_SMART_LIST[ERROR]:
      return state.setIn(['lists', 'state'], fetchingState.ERROR);

    case smartListActions.INSERT_SMART_LIST[START]:
      return state.setIn(['lists', 'state'], fetchingState.FETCHING);
    case smartListActions.INSERT_SMART_LIST[SUCCESS]:
      let newState = state.setIn(['lists', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['lists', 'data'],
        fromJS(
          state
            .getIn(['lists', 'data'])
            .toJS()
            .concat(data ? data.results : []),
        ),
      );
    case smartListActions.INSERT_SMART_LIST[ERROR]:
      return state.setIn(['lists', 'state'], fetchingState.ERROR);

    case smartListActions.UPDATE_SMART_LIST[SUCCESS]:
      return updateStateArrayItem(state, data, 'lists', 'smartListID');

    case smartListActions.FETCH_SMART_LIST_MODULES[START]:
      newState = state.setIn(['modules', 'data'], fromJS([]));
      return newState.setIn(['modules', 'state'], fetchingState.FETCHING);
    case smartListActions.FETCH_SMART_LIST_MODULES[SUCCESS]:
      newState = state.setIn(['modules', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['modules', 'data'],
        fromJS(data ? data.results : []),
      );
    case smartListActions.FETCH_SMART_LIST_MODULES[ERROR]:
      return state.setIn(['modules', 'state'], fetchingState.ERROR);

    case smartListActions.FETCH_SMART_LIST_GROUPS[START]:
      newState = state.setIn(['groups', 'data'], fromJS([]));
      return newState.setIn(['groups', 'state'], fetchingState.FETCHING);
    case smartListActions.FETCH_SMART_LIST_GROUPS[SUCCESS]:
      newState = state.setIn(['groups', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['groups', 'data'],
        fromJS(data ? data.results : []),
      );
    case smartListActions.FETCH_SMART_LIST_GROUPS[ERROR]:
      return state.setIn(['groups', 'state'], fetchingState.ERROR);

    case smartListActions.FETCH_ALL_APPRAISAL_USERS[START]:
      newState = state.setIn(['appraisalUsers', 'data'], fromJS([]));
      return newState.setIn(
        ['appraisalUsers', 'state'],
        fetchingState.FETCHING,
      );
    case smartListActions.FETCH_ALL_APPRAISAL_USERS[SUCCESS]:
      newState = state.setIn(['appraisalUsers', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['appraisalUsers', 'data'],
        fromJS(data ? data.results : []),
      );
    case smartListActions.FETCH_ALL_APPRAISAL_USERS[ERROR]:
      return state.setIn(['appraisalUsers', 'state'], fetchingState.ERROR);

    case smartListActions.FETCH_ALL_APPRAISAL_ROLES[START]:
      newState = state.setIn(['appraisalRoles', 'data'], fromJS([]));
      return newState.setIn(
        ['appraisalRoles', 'state'],
        fetchingState.FETCHING,
      );
    case smartListActions.FETCH_ALL_APPRAISAL_ROLES[SUCCESS]:
      newState = state.setIn(['appraisalRoles', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['appraisalRoles', 'data'],
        fromJS(data ? data.results : []),
      );
    case smartListActions.FETCH_ALL_APPRAISAL_ROLES[ERROR]:
      return state.setIn(['appraisalRoles', 'state'], fetchingState.ERROR);

    case smartListActions.INSERT_USER_ACCESS[START]:
      return state.setIn(['userAccess', 'state'], fetchingState.FETCHING);
    case smartListActions.INSERT_USER_ACCESS[SUCCESS]:
      newState = state.setIn(['userAccess', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['userAccess', 'data'],
        fromJS(
          state
            .getIn(['userAccess', 'data'])
            .toJS()
            .concat(data ? data.results : []),
        ),
      );
    case smartListActions.INSERT_USER_ACCESS[ERROR]:
      return state.setIn(['userAccess', 'state'], fetchingState.ERROR);

    case smartListActions.DELETE_USER_ACCESS[SUCCESS]:
      newState = state.setIn(['userAccess', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['userAccess', 'data'],
        fromJS(
          state
            .getIn(['userAccess', 'data'])
            .toJS()
            .filter(u => u.smartListUserID !== other.smartListUserId),
        ),
      );

    case smartListActions.FETCH_USER_ACCESS[START]:
      newState = state.setIn(['userAccess', 'data'], fromJS([]));
      return newState.setIn(['userAccess', 'state'], fetchingState.FETCHING);
    case smartListActions.FETCH_USER_ACCESS[SUCCESS]:
      newState = state.setIn(['userAccess', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['userAccess', 'data'],
        fromJS(data ? data.results : []),
      );
    case smartListActions.FETCH_USER_ACCESS[ERROR]:
      return state.setIn(['userAccess', 'state'], fetchingState.ERROR);

    case smartListActions.FETCH_ROLE_ACCESS[START]:
      newState = state.setIn(['roleAccess', 'data'], fromJS([]));
      return newState.setIn(['roleAccess', 'state'], fetchingState.FETCHING);
    case smartListActions.FETCH_ROLE_ACCESS[SUCCESS]:
      newState = state.setIn(['roleAccess', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['roleAccess', 'data'],
        fromJS(data ? data.results : []),
      );
    case smartListActions.FETCH_ROLE_ACCESS[ERROR]:
      return state.setIn(['roleAccess', 'state'], fetchingState.ERROR);

    case smartListActions.INSERT_ROLE_ACCESS[START]:
      return state.setIn(['roleAccess', 'state'], fetchingState.FETCHING);
    case smartListActions.INSERT_ROLE_ACCESS[SUCCESS]:
      newState = state.setIn(['roleAccess', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['roleAccess', 'data'],
        fromJS(
          state
            .getIn(['roleAccess', 'data'])
            .toJS()
            .concat(data ? data.results : []),
        ),
      );
    case smartListActions.INSERT_ROLE_ACCESS[ERROR]:
      return state.setIn(['roleAccess', 'state'], fetchingState.ERROR);

    case smartListActions.DELETE_ROLE_ACCESS[SUCCESS]:
      newState = state.setIn(['roleAccess', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['roleAccess', 'data'],
        fromJS(
          state
            .getIn(['roleAccess', 'data'])
            .toJS()
            .filter(u => u.smartListRoleID !== other.smartListRoleId),
        ),
      );

    case smartListActions.INSERT_PARAMETER[START]:
      return state.setIn(['parameters', 'state'], fetchingState.FETCHING);
    case smartListActions.INSERT_PARAMETER[SUCCESS]:
      newState = state.setIn(['parameters', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['parameters', 'data'],
        fromJS(
          state
            .getIn(['parameters', 'data'])
            .toJS()
            .concat(data ? data.results : []),
        ),
      );
    case smartListActions.INSERT_PARAMETER[ERROR]:
      return state.setIn(['parameters', 'state'], fetchingState.ERROR);

    case smartListActions.UPDATE_PARAMETER[SUCCESS]:
      return updateStateArrayItem(
        state,
        data,
        'parameters',
        'smartListParameterID',
      );

    case smartListActions.DELETE_PARAMETER[SUCCESS]:
      return state.setIn(
        ['parameters', 'data'],
        fromJS(
          state
            .getIn(['parameters', 'data'])
            .toJS()
            .filter(u => u.smartListParameterID !== other.smartListParameterId),
        ),
      );

    case smartListActions.FETCH_ALL_PARAMETERS[START]:
      newState = state.setIn(['parameters', 'data'], fromJS([]));
      return newState.setIn(['parameters', 'state'], fetchingState.FETCHING);
    case smartListActions.FETCH_ALL_PARAMETERS[SUCCESS]:
      newState = state.setIn(['parameters', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['parameters', 'data'],
        fromJS(data ? data.results : []),
      );
    case smartListActions.FETCH_ALL_PARAMETERS[ERROR]:
      return state.setIn(['parameters', 'state'], fetchingState.ERROR);

    case smartListActions.CLEAR_PARAMETERS:
      newState = state.setIn(['parameters', 'data'], fromJS([]));
      return newState.setIn(['parameters', 'state'], fetchingState.LOADED);

    case smartListActions.EXECUTE_QUERY_PREVIEW[START]:
      newState = state.setIn(['executePreview', 'errorMsg'], '');
      newState = newState.setIn(['executePreview', 'recordCount'], 0);
      newState = newState.setIn(['executePreview', 'data'], fromJS([]));
      return newState.setIn(
        ['executePreview', 'state'],
        fetchingState.FETCHING,
      );
    case smartListActions.EXECUTE_QUERY_PREVIEW[SUCCESS]:
      newState = state.setIn(['executePreview', 'state'], fetchingState.LOADED);
      newState = newState.setIn(
        ['executePreview', 'recordCount'],
        data.results.recordCount,
      );
      newState = newState.setIn(
        ['executePreview', 'columnOrder'],
        fromJS(
          data && data.results.queryResults[0]
            ? Object.keys(data.results.queryResults[0])
            : [],
        ),
      );
      if (data.results.query) {
        newState = newState.setIn(
          ['executePreview', 'query'],
          fromJS(data && data.results.query ? data.results.query : null),
        );
      }
      if (data.results.pIDQuery) {
        newState = newState.setIn(
          ['executePreview', 'pIDQuery'],
          fromJS(data && data.results.pIDQuery ? data.results.pIDQuery : null),
        );
      }
      if (data.results.jaspersoftQuery) {
        newState = newState.setIn(
          ['executePreview', 'jaspersoftQuery'],
          fromJS(
            data && data.results.jaspersoftQuery
              ? data.results.jaspersoftQuery
              : null,
          ),
        );
      }
      return newState.setIn(
        ['executePreview', 'data'],
        fromJS(data ? data.results.queryResults : []),
      );
    case smartListActions.EXECUTE_QUERY_PREVIEW[ERROR]:
      newState = state.setIn(['executePreview', 'state'], fetchingState.ERROR);
      return newState.setIn(
        ['executePreview', 'errorMsg'],
        `${other.error.name}: ${other.error.body.warning}`,
      );

    case smartListActions.DELETE_SMART_LIST[SUCCESS]:
      return state.setIn(
        ['searchResultList', 'data'],
        fromJS(
          state
            .getIn(['searchResultList', 'data'])
            .toJS()
            .filter(u => u.smartListID !== other.smartListId),
        ),
      );

    case smartListActions.FETCH_SMART_LIST_TYPES[START]: {
      return state
        .setIn(['typeList', 'data'], fromJS([]))
        .setIn(['typeList', 'state'], fetchingState.FETCHING);
    }
    case smartListActions.FETCH_SMART_LIST_TYPES[SUCCESS]: {
      return state
        .setIn(['typeList', 'state'], fetchingState.LOADED)
        .setIn(['typeList', 'data'], fromJS(_.get(data, 'results', [])));
    }
    case smartListActions.FETCH_SMART_LIST_TYPES[ERROR]: {
      return state.setIn(['typeList', 'state'], fetchingState.ERROR);
    }

    case smartListActions.FETCH_SMART_LIST_SEARCH_CONFIG[START]: {
      return state
        .setIn(['searchConfigList', 'data'], fromJS([]))
        .setIn(['searchConfigList', 'state'], fetchingState.FETCHING);
    }
    case smartListActions.FETCH_SMART_LIST_SEARCH_CONFIG[SUCCESS]: {
      return state
        .setIn(['searchConfigList', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchConfigList', 'data'],
          fromJS(_.get(data, 'results', [])),
        );
    }
    case smartListActions.FETCH_SMART_LIST_SEARCH_CONFIG[ERROR]: {
      return state.setIn(['searchConfigList', 'state'], fetchingState.ERROR);
    }

    case smartListActions.FETCH_SMART_LIST_SEARCH_CONFIG_RESULTS[START]: {
      return state
        .setIn(['searchConfigResultList', 'data'], fromJS([]))
        .setIn(['searchConfigResultList', 'state'], fetchingState.FETCHING);
    }
    case smartListActions.FETCH_SMART_LIST_SEARCH_CONFIG_RESULTS[SUCCESS]: {
      return state
        .setIn(['searchConfigResultList', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchConfigResultList', 'data'],
          fromJS(_.get(data, 'results', [])),
        );
    }
    case smartListActions.FETCH_SMART_LIST_SEARCH_CONFIG_RESULTS[ERROR]: {
      return state.setIn(
        ['searchConfigResultList', 'state'],
        fetchingState.ERROR,
      );
    }

    case smartListActions.SEARCH_SMART_LIST[START]: {
      return state
        .setIn(['searchResultList', 'searchOptions'], fromJS(other.payload))
        .setIn(['searchResultList', 'data'], fromJS([]))
        .setIn(['searchResultList', 'state'], fetchingState.FETCHING)
        .setIn(['searchResultList', 'pagination', 'page'], other.page)
        .setIn(
          ['searchResultList', 'pagination', 'rowsPerPage'],
          other.pageSize,
        );
    }
    case smartListActions.SEARCH_SMART_LIST[SUCCESS]: {
      return state
        .setIn(['searchResultList', 'state'], fetchingState.LOADED)
        .setIn(['searchResultList', 'data'], fromJS(_.get(data, 'results', [])))
        .setIn(
          ['searchResultList', 'pagination', 'count'],
          _.get(data, 'totalProperty.smartListCount', 0),
        );
    }
    case smartListActions.SEARCH_SMART_LIST[ERROR]: {
      return state.setIn(['searchResultList', 'state'], fetchingState.ERROR);
    }

    case smartListActions.SEARCH_VALIDATION_SMART_LIST[START]: {
      return state
        .setIn(
          ['searchValidationResultList', 'searchOptions'],
          fromJS(other.payload),
        )
        .setIn(['searchValidationResultList', 'data'], fromJS([]))
        .setIn(['searchValidationResultList', 'state'], fetchingState.FETCHING)
        .setIn(['searchValidationResultList', 'pagination', 'page'], other.page)
        .setIn(
          ['searchValidationResultList', 'pagination', 'rowsPerPage'],
          other.pageSize,
        );
    }
    case smartListActions.SEARCH_VALIDATION_SMART_LIST[SUCCESS]: {
      return state
        .setIn(['searchValidationResultList', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchValidationResultList', 'data'],
          fromJS(_.get(data, 'results', [])),
        )
        .setIn(
          ['searchValidationResultList', 'pagination', 'count'],
          _.get(data, 'totalProperty.smartListCount', 0),
        );
    }
    case smartListActions.SEARCH_VALIDATION_SMART_LIST[ERROR]: {
      return state.setIn(
        ['searchValidationResultList', 'state'],
        fetchingState.ERROR,
      );
    }

    case smartListActions.RESET_EXECUTE_DATA: {
      return state
        .setIn(['executePreview', 'data'], [])
        .setIn(['executePreview', 'recordCount'], 0);
    }

    case smartListActions.CHANGE_PAGE: {
      return state.setIn(
        ['searchResultList', 'pagination', 'page'],
        other.payload,
      );
    }
    case smartListActions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(
        ['searchResultList', 'pagination', 'rowsPerPage'],
        other.payload,
      );
    }
    case smartListActions.CHANGE_SORT_MODEL: {
      return state.setIn(
        ['searchResultList', 'pagination', 'sortModel'],
        fromJS(other.payload),
      );
    }

    case smartListActions.DELETE_USER_FAVORITE[SUCCESS]:
      return state.setIn(
        ['searchResultList', 'data'],
        fromJS(
          state
            .getIn(['searchResultList', 'data'])
            .toJS()
            .map(x =>
              x.smartListID === other.smartListId
                ? {
                    ...x,
                    favorite: 0,
                  }
                : x,
            ),
        ),
      );

    case smartListActions.INSERT_USER_FAVORITE[SUCCESS]:
      return state.setIn(
        ['searchResultList', 'data'],
        fromJS(
          state
            .getIn(['searchResultList', 'data'])
            .toJS()
            .map(x =>
              x.smartListID === _.get(data, 'results[0].smartListID')
                ? {
                    ...x,
                    favorite: 1,
                  }
                : x,
            ),
        ),
      );

    default: {
      return state;
    }
  }
};

export default SmartListReducer;
